import { render, staticRenderFns } from "./m-copyBtn.vue?vue&type=template&id=78e0b7e2&"
import script from "./m-copyBtn.vue?vue&type=script&lang=ts&"
export * from "./m-copyBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports